import { Fragment } from "react";
import { FormattedMessage as FM } from "react-intl";

import { BUTTON_COLORS } from "components/Constants/constants";
import Button from "componentsv2/button/Button";
import { useTable } from "storev2/tableStore";
import { classNames as cn } from "tools/ui";

function TButtonCustomModal(props) {
  const { field, model, record, layout, parentRec, readOnly } = props;
  const { name, color, Component, customName = () => null, label } = field;
  const { openModalTable } = useTable();
  const [bgColor, txtColor, border] =
    BUTTON_COLORS[color] || BUTTON_COLORS["neutralDark"];
  const _name =
    customName(name, record) || `${model}.${name}` || "custom_button";
  const _label = label || name;
  const isDisabled = readOnly === true;

  const handleOpenModal = (e) => {
    e.stopPropagation();
    if (isDisabled) return;
    openModalTable(Component, props, _label);
  };

  return (
    <Fragment>
      <Button
        disabled={isDisabled}
        onClick={handleOpenModal}
        color={color}
        height={"h-8"}
        style={cn("border mx-auto", border, bgColor, txtColor)}
      >
        <FM id={_name} />
      </Button>
    </Fragment>
  );
}

export default TButtonCustomModal;
